import React from 'react';
import PropTypes from 'prop-types';

// @ components
import Headline from 'components/headline';

// @ commons
import { i18n } from 'core/i18n';

const { FormattedText } = i18n;

const HeadlineTitle = ({ icon, text, cssClass, subtitle }) => {
    return (
        <Headline icon={icon} className={cssClass}>
            <h2>
                <FormattedText value={text} />
            </h2>
            {subtitle && <p><FormattedText value={subtitle} /></p>}
        </Headline>
    );
};

HeadlineTitle.propTypes = {
    icon: PropTypes.string,
    text: PropTypes.string,
    subtitle: PropTypes.string,
    cssClass: PropTypes.string,
};

HeadlineTitle.defaultProps = {
    icon: 'tarjeta',
    text: 'stepsTitles-openCreditJaffarApproved',
    cssClass: 'prospects-gutter',
};

export default HeadlineTitle;
